<template>
    <div id="parent">
        <div class="header">
            <div class="left">
                <div class="prev-css icon iconfont icon-zuojiantou" @click="prev"></div>
                {{headerContent}}
                <div class="prev-css icon iconfont icon-youjiantou" @click="next"></div>
            </div>
        </div>
        <div class="body">
            <table class="month-table" cellspacing="0" cellpadding="0" v-show="showMonth && period == '2' ">
                <tbody>
                <tr style="text-align: center; height: 60px;">
                    <td>周一</td>
                    <td>周二</td>
                    <td>周三</td>
                    <td>周四</td>
                    <td>周五</td>
                    <td>周六</td>
                    <td>周七</td>
                </tr>
                <!-- 双重for循环生成 6 * 7 = 42 个日期格子 -->
                <tr v-for="(week, weekIndex) in dates" v-bind:key="weekIndex" style="height: 160px;">
                    <td class="hand-css" v-for="(date, dateIndex) in dates[weekIndex]" v-bind:key="dateIndex"
                        @mouseenter="dateMouseEnter(weekIndex, dateIndex)"
                        @mouseleave="dateMouseLeave(weekIndex, dateIndex)">
                        <div class="date" :class="[date.class, date.isAlive]">
                            <span>{{date.day}}</span>
                            <div v-if="monthData[date.value]" style="display: flex; flex-wrap: wrap; justify-content: space-between; height: 120px; align-items: flex-start; padding: 5px; overflow: auto;">
                                <div v-for="(item,journeyIndex) in monthData[date.value].clientList" :kye="journeyIndex"
                                    class="personClient">
                                    <img width="20px" :src="item.src" style="vertical-align: middle"/>
                                    <span style="margin-left: 5px">{{item.name}}</span>
                                </div>
                            </div>
                        </div>

                    </td>
                </tr>
                </tbody>
            </table>
            <!-- 生成一个周 时间列表 -->
            <table class="week-table" cellspacing="0" cellpadding="0" v-show="!showMonth && period == '1'">
                <thead>
                <th style="height: 60px; border: 1px solid #EBEEF5;">时间</th>
                <th style="height: 60px;border: 1px solid #EBEEF5;" v-for="(header, index) in weekTableHeader"
                    :key="index" :class="header.class">{{header.date}}
                </th>
                </thead>
                <tbody>
                <tr v-for="(hourMinute, index) in weekList" :key="index" style="height: 70px;">
                    <td>
                        <div class="hours">
                            <span>{{hourMinute.value}}</span>
                        </div>
                    </td>
                    <td v-for="(header, index) in weekTableHeader" :key="index" class="hand-css">
                        <div v-if="weekData[header['value']] && weekData[header['value']][hourMinute['key']]" style="display: flex; flex-wrap: wrap; justify-content: space-between; height: 70px; align-items: flex-start; padding: 5px; overflow: auto;">
                            <div class="personClient" v-for="(item,journeyIndex) in weekData[header['value']][hourMinute['key']].clientList" :key="journeyIndex" >
                                <img width="20px" :src="item.src" style="vertical-align: middle"/>
                                <span style="margin-left: 5px" v-if="item.type == 1" @click.stop="edit" :data-id="item.client_id" :data-name="item.name">{{item.name}}:{{item.remark}}</span>
								<span style="margin-left: 5px" v-if="item.type == 2" @click.stop="edit" :data-id="item.client_id" :data-name="item.name">{{item.name}}:{{item.remark}}(预约上门)</span>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <!-- 任务详情提示框 -->
            <!-- 编辑任务提示框 -->
            <Modal :scrollable='true' v-model="editTasklModal" :closable="false" width="900">
                <div slot="footer">
                    <Button type="primary" @click="$refs['editTask'].save()">确定</Button>
                </div>
            </Modal>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import {taskStatusOperate} from '@/api/task'
    import ShouyeEditTask from './shouyeEditTask.vue'
    import {mapActions, mapGetters} from "vuex";

    export default {
        components: {
            ShouyeEditTask,
        },
        props: [
            'period',
            'weekData',
            'monthData',
        ],
        data() {
            return {
                journey: [
                    {
                        date: '2021-01-02',
                        time: '7:00-8:00',
                        src: require("../../assets/images/yu.png"),
                        name: '张兵'
                    },
                    {
                        date: '2020-01-03',
                        time: '7:00-8:00',
                        src: require("../../assets/images/yu.png"),
                        name: '张兵'
                    },
                    {
                        date: '2020-01-04',
                        time: '7:00-8:00',
                        src: require("../../assets/images/shangmen.png"),
                        name: '张兵'
                    },
                ],
                modal4: false,//新建任务对话框显示
                editTasklModal: false,//编辑任务对话框显示
                dianjibiaoge: {}, //点击事件文字需获取到的数据
                taskDetailModal: false, //任务详情对话框显示
                checkShow: false, //时间勾选样式
                today: moment().format('YYYY-MM-DD'),
                currentYearMonth: moment().format('YYYY-MM'),
                weekTableHeader: [],
                dates: [],
                showMonth: false,
                weekList: [],
                //初始化页面显示的东西
                headerContent: moment().format('YYYY-MM'),
                currentWeekday: '',

                initData: {}
            }
        },
        computed: {
            ...mapGetters(['token']),
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            // 新建任务
            addTaskClick() {
                this.modal4 = true
            },
            //监听子组件传出来的事件
            editTasklModalClick() {
                this.editTasklModal = false
            },
            //点击任务详情对话框里面的编辑任务触发
            editTaskClick() {
                this.editTasklModal = true
                this.taskDetailModal = false
            },
            //事件中的文字点击触发
            taskDetailsClick(id) {
                this.initData = {id: id};
                this.taskDetailModal = true
            },
            // 完成或者未完成
            checkOut(id) {
                let that = this;
                let data = {id: id};
                data.token = that.token;
                that.throttle(async () => {
                    let res = await taskStatusOperate(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.$emit('getList')
                    }
                }, 2000)
            },
            // 点击上个月 通过改变currentYearMonth来获取上个月的 YYYY-MM 格式
            prev() {
                if (this.showMonth) {
                    this.currentYearMonth = moment(this.currentYearMonth).subtract(1, 'months').format('YYYY-MM')
                    this.headerContent = this.currentYearMonth
                    this.createCalendar()
                } else {
                    this.currentWeekday = moment(this.currentWeekday).subtract(7, 'days')
                    this.weekHeaderContent()
                    this.createWeekList()
                }
                this.$emit('getList')
            },
            next() {
                if (this.showMonth) {
                    this.currentYearMonth = moment(this.currentYearMonth).add(1, 'months').format('YYYY-MM')
                    this.headerContent = this.currentYearMonth
                    this.createCalendar()
                } else {
                    this.currentWeekday = moment(this.currentWeekday).add(7, 'days')
                    this.weekHeaderContent()
                    this.createWeekList()
                }
                this.$emit('getList')
            },
            switchWeek() {
                this.showMonth = true
                this.headerContent = this.currentYearMonth
            },
            switchMonth() {
                this.showMonth = false
                this.weekHeaderContent()
            },
            dateMouseEnter(weekIndex, dateIndex) {
                this.dates[weekIndex][dateIndex].isAlive = 'date-alive'
            },
            dateMouseLeave(weekIndex, dateIndex) {
                this.dates[weekIndex][dateIndex].isAlive = ''
            },
			edit(e) {
				let that = this;
				let id = e.id || e.currentTarget.dataset.id;
				let name = e.name || e.currentTarget.dataset.name;
				console.log(name)
				this.$nextTick(function() {
					/*
					  that.oldDatas = that.datas;
					  that.editModal = true;
					  */
					this.$router.push({
						name: "newEditClue",
						params: {
							id: id,
							name: name,
							data: that.datas,
						},
					});
				});
			},
            createCalendar() {
                this.dates = []
                // 获取当月的一号是星期几 以便来生成上月的日期 填补够42个格子
                const monthFirstDay = moment(this.currentYearMonth + '-01', 'YYYY-MM-DD')
                // 获得一号与第一个格子内应该有的天数距离 这里需要注意的是 weekday 是从周日 为 0 开始的
                let firstDayWeekday = moment(monthFirstDay).weekday()
                if (firstDayWeekday === 0) {
                    firstDayWeekday = 7
                }
                let daysDistance = 1 - firstDayWeekday
                for (let weeks = 0; weeks < 5; weeks++) {
                    this.dates.push([])
                    for (let weekday = 0; weekday < 7; weekday++) {
                        // 该对象有两个属性 一个是class属性 还有一个就是日期
                        let date = {}
                        date.day = moment(monthFirstDay).add(daysDistance, 'days')
                        date.value = date.day.format('YYYY-MM-DD')
                        date.isAlive = ''
                        const dayMonth = moment(date.day).month()
                        // 是这个月的日期
                        if (dayMonth === moment(monthFirstDay).month()) {
                            date.class = 'current-month '
                            // 日期是今天的高亮
                            if (moment(date.day).isSame(this.today, 'days')) {
                                date.class += 'today '
                            }
                        } else {
                            date.class = 'not-current-month '
                        }
                        date.day = moment(date.day).format('DD')
                        this.dates[weeks].push(date)
                        daysDistance++
                    }
                }
            },
            createWeekList() {
                this.weekTableHeader = ['周一 ', '周二 ', '周三 ', '周四 ', '周五 ', '周六 ', '周日 ']
                this.weekList = []
                for (let index = 0; index < 7; index++) {
                    let item = {}
                    item.date = moment(this.currentWeekday).add(index, 'days')
                    if (item.date.isSame(this.today, 'days')) {
                        item.class = 'today'
                    }
                    item.value = item.date.format('YYYY-MM-DD');
                    item.date = this.weekTableHeader[index] + item.date.format('MM/DD')
                    this.weekTableHeader[index] = item
                }
                for (let hours = 0; hours < 14; hours++) {
                    let value = hours + 7 + ':00-' + (hours + 8 + ':00')
                    let key = hours + 7;
                    let item = {key, value}
                    this.weekList.push(item)
                }
            },
            weekHeaderContent() {
                this.headerContent = moment(this.currentWeekday).format('YYYY-MM')
                //moment(this.currentWeekday).format('MM/DD') + '~' + moment(this.currentWeekday).add(6, 'days').format('MM/DD')
            },
            addTaskAfter() {
                this.editTasklModal = false;
                this.$emit('getList');
            }
        },
        created() {
            // v-show是在创建后 保留dom 只是做切换的 不会v-if那样 销毁dom 所以只需要创建一次
            this.createCalendar()
            let weekday = moment().weekday() === 0 ? 7 : moment().weekday()
            let daysDistance = 1 - weekday
            this.currentWeekday = moment().add(daysDistance, 'days')
            this.createWeekList()
        }
    }
</script>

<style lang="less" scoped>
    .prev-css {
        color: #277dd3;
        font-size: 30px;
        cursor: pointer;
    }

    .left {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .hand-css {
        cursor: pointer;
    }

    .journeytext {
        color: #999999;
        text-decoration: line-through
    }

    .checkcss {
        color: #FF0000;
        text-decoration: none
    }

    .yuanlan {
        height: 7px;
        width: 7px;
        border-radius: 50%;
        margin: 0 1px;
        padding-right: 5px;
    }

    .bg-blue {
        background-color: #277dd3;
    }

    .bg-pink {
        background-color: rgb(255, 141, 141)
    }

    .bg-green {
        background-color: rgb(0, 163, 178);
    }

    .scrollbar-css::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .scrollbar-css::-webkit-scrollbar-thumb {
        border-radius: 3px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
        background: #cae1f5;
    }

    .scrollbar-css::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background: #fff;
    }

    .fill {
        font-size: 15px;
        margin-left: 5px;
        color: #277dd3;
    }

    .fill-month {
        font-size: 15px;
        color: #277dd3;
    }

    #parent {
        margin: 0 auto;
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding: 12px 20px;
        font-size: 18px;
    }

    .body {
        padding: 12px 20px 35px;
    }

    table {
        table-layout: fixed;
        width: 100%;
    }

    table thead th {
        padding: 10px 0;
        font-weight: 400;
    }

    tbody tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
    }

    .month-table tbody td {
        vertical-align: inherit;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
    }

    .month-table tbody tr:first-child td {
        border-top: 1px solid #ebeef5;
    }

    .month-table tr td:first-child {
        border-left: 1px solid #ebeef5;
    }

    .date {
        box-sizing: border-box;
        padding: 8px;
        height: 160px;
        overflow: auto;
    }

    .date::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .date::-webkit-scrollbar-thumb {
        border-radius: 3px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
        background: #cae1f5;
    }

    .date::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background: #fff;
    }

    .not-current-month {
        color: #909399;
    }

    .current-month {
        color: #000000;
    }

    .today {
        color: #000000;
        background-color: #F5FBFF;
    }

    .date-alive {
        background-color: rgb(252, 212, 215);
    }

    .week-table tbody tr td {
        border: 1px solid #ebeef5;
    }

    .hours {
        text-align: center;
        height: 24px;
    }
    .personClient{
        display: flex; align-items: center; width: 150px;justify-content: start; color: red;
        overflow: hidden;
    }
</style>
